import {Injectable} from '@angular/core';
import { FinzyVersion } from '../model/common/investment-product';
import { ConfigService } from '../service/config.service';
import {Keys, StorageService} from '../service/storage.service';

@Injectable()
export class PageMapping {
    public static readonly LENDER_PAGE_PATH_PREFIX = 'invest';
    public static readonly BORROWER_PAGE_PATH_PREFIX = 'borrow';
    public static readonly CIBIL_PAGE_PATH_PREFIX = 'cibil/check-user-details';
    protected readonly storageService: StorageService;
    private configService: ConfigService;


    constructor(storageService: StorageService, configService: ConfigService) {
      this.storageService = storageService;
      this.configService = configService;
    }
    private lenderPages = new Set(['invest', 'lenderintro', 'lenderpersonalinfo',
        'lenderbankdetails', 'lenderuploaddocuments', 'lendersummary', 'lenderinitial', 'investordashboard',
        'preferences', 'investorwallet', 'lenderpassbook', 'lenderconsent', 'interest-certificate']);

    private lenderApplicationFilledStatusRedirectLinkMap = new Map<string, string>()
        .set('email-verification', '/invest/email-verification')
        .set('otp_verified', '/lenderpersonalinfo')
        .set('personal_info', '/invest/residence-info')
        .set('residence_proof', '/lenderbankdetails')
        .set('document_upload', '/lenderuploaddocuments')
        .set('bank_details_filled', '/invest/lender-nominee');

    private lenderApplicationProcessedStatusRedirectLinkMap = new Map<string, string>()
        .set('ready_for_kyc', '/lenderinitial')
        .set('kyc_in_progress', '/lenderinitial')
        .set('verified', '/lenderinitial')
        .set('invested', '/investordashboard');

    private lenderApplicationProcessedStatusRedirectLinkMap_Finzy_V2 = new Map<string, string>()
        .set('ready_for_kyc', '/investment-initial')
        .set('kyc_in_progress', '/investment-initial')
        .set('flex_user', '/investordashboard')
        .set('verified', '/finzy-flex/dashboard')
        .set('invested', '/finzy-flex/dashboard');

    public whereShouldTheBorrowerBe(): string {
        return '/borrow/dashboard/applications';
    }

    public whereShouldTheLenderBe(lenderApplicationStatus: string, applicationProcessedStatus?: string): string {
    const activeFinzyVersion = this.configService.getActiveFinzyVersion();
        if (this.lenderApplicationProcessedStatusRedirectLinkMap.has(applicationProcessedStatus)) {
            if (activeFinzyVersion === FinzyVersion.FINZY_V2){

                // navigation FINX user to finzyPro dashboard
                const isFINXLender = this.storageService.getItem(Keys.FINX) == "true" && this.storageService.getItem(Keys.IS_LENDER_CREATED_AFTER_RESTRICTED_DATE) === "true" ? true: false;

                if(isFINXLender) {
                    return this.lenderApplicationProcessedStatusRedirectLinkMap_Finzy_V2.get('flex_user');
                }
                return this.lenderApplicationProcessedStatusRedirectLinkMap_Finzy_V2.get(applicationProcessedStatus);
            }
            return this.lenderApplicationProcessedStatusRedirectLinkMap.get(applicationProcessedStatus);
        } else {
            if (lenderApplicationStatus === 'bank_details_filled' && !!this.storageService.getItem(Keys.LENDER_NOMINEE) &&
                !!!this.storageService.getItem(Keys.INVESTMENT_PREFERENCES)) {
                return '/invest/investment-preferences';
            } else {
                return this.lenderApplicationFilledStatusRedirectLinkMap.get(lenderApplicationStatus);
            }
        }
    }

    public isLenderPage(url: string): boolean {
        const urlFragments = url.split('/');
        return url.startsWith(`/${PageMapping.LENDER_PAGE_PATH_PREFIX}`) ||
            (urlFragments.length > 1 ? this.lenderPages.has(urlFragments[1]) : false);
    }

    public isBorrowerPage(url: string): boolean {
        return url.startsWith(`/${PageMapping.BORROWER_PAGE_PATH_PREFIX}`);
    }
}
